module.exports = __webpack_public_path__ + "img/department.96c3d1dc.svg";